(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["liore-product-details"] && !Shopify.designMode) return;
  try {
    
  function activateLioreProductDetailsTab(tab) {
    const section = tab.closest('[data-liore-product-details]');
    if (!section) return;

    const tabs = [...section.querySelectorAll('[data-liore-product-details-tab]')];
    const panels = [...section.querySelectorAll('[data-liore-product-details-panel]')];

    tabs.forEach((candidate) => {
      const isSelected = candidate === tab;
      candidate.classList.toggle('is-active', isSelected);
      candidate.setAttribute('aria-selected', String(isSelected));
      candidate.tabIndex = isSelected ? 0 : -1;
    });

    panels.forEach((panel) => {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-liore-product-details-tab]');
    if (!tab) return;

    activateLioreProductDetailsTab(tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-liore-product-details-tab]');
    if (!tab) return;

    const tabs = [...tab.closest('[data-liore-product-details]').querySelectorAll('[data-liore-product-details-tab]')];
    const currentIndex = tabs.indexOf(tab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    if (nextIndex === currentIndex) return;

    event.preventDefault();
    tabs[nextIndex].focus();
    activateLioreProductDetailsTab(tabs[nextIndex]);
  });

  document.addEventListener('shopify:product:select', (event) => {
    event.promise
      .then(({ detail }) => {
        if (!detail?.productId) return;

        document
          .querySelectorAll(
            `[data-liore-product-details][data-product-id="${CSS.escape(String(detail.productId))}"]`
          )
          .forEach((section) => {
            const skuRow = section.querySelector('[data-liore-product-sku]');
            const skuValue = section.querySelector('[data-liore-product-sku-value]');
            if (!skuRow || !skuValue) return;

            const sku = detail.resource?.sku?.trim() ?? '';
            skuValue.textContent = sku;
            skuRow.hidden = sku === '';
          });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[liore-product-details] SKU update failed:', error);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
